import {
    FETCH_CAPABILITY_CALL_SUCCESS,
    FETCH_CYCLES_CALL_SUCCESS,
    FETCH_FILTERS_CALL_SUCCESS,
    FETCH_OPTIONS_CALL_BEGIN,
    FETCH_OPTIONS_CALL_FAILURE,
    NAVIGATION_ADDED,
    NAVIGATION_REMOVED, OPTION_REMOVE_ALL,
    OPTION_REMOVED,
    OPTIONS_ADDED_OR_CHANGED,
    OPTIONS_BUTTON_CLICKED, VIEW_CHANGED
} from "../actions/OptionsActions";
import {setSelectedCycle} from "../handler/ParentDataHandler";
import {Capability, ViewType} from "../enums";

/**
 * Initial state of the options menu
 */
const initialState = {
    showingOptionsMenu: false,
    options: {
        cycle: "",
        cycleId: "",
        associateStatuses: [],
        machineStatuses: [],
        clusters: []
    },
    heatMapView: ViewType.DEFAULT_VIEW,
    isInitialView: true,
    navigationOptions: [],
    loading: false,
    allCycles: [],
    allClusters: [],
    allAisles: [],
    capability: Capability.AMZL,
    clusterAislesMap: {}
};

export default function optionsReducer(state = initialState, action) {
    let newState;
    switch (action.type) {
        case OPTIONS_BUTTON_CLICKED:
            return {
                ...state,
                showingOptionsMenu: !state.showingOptionsMenu
            };

        case OPTIONS_ADDED_OR_CHANGED:
            newState = {
                ...state,
                options: Object.assign({}, state.options, action.options)
            }
            setSelectedCycle([newState.options.cycle]);
            return newState;
        case OPTION_REMOVED:
            if (Array.isArray(state.options[action.removedOption])) {
                const newArray = state.options[action.removedOption].filter(optionValue => optionValue !== action.removedOptionValue)
                newState = {
                    ...state,
                    options: {
                        ...state.options,
                        [action.removedOption]: newArray
                    }
                }
                setSelectedCycle([newState.options.cycle]);
                return newState;
            }
            // Using Destructuring assignment
            const {[action.removedOption]: value, ...newOptions} = state.options;
            return {
                ...state,
                options: newOptions
            }
        case OPTION_REMOVE_ALL:
            return {
                ...state,
                options: initialState.options
            }
        case NAVIGATION_ADDED:
            return {
                ...state,
                navigationOptions: [...state.navigationOptions, action.navigationOption]
            }
        case NAVIGATION_REMOVED:
            return {
                ...state,
                navigationOptions: [...state.navigationOptions.slice(0, action.navigationIndex)]
            }

        case FETCH_OPTIONS_CALL_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_CAPABILITY_CALL_SUCCESS:
            const capability = JSON.parse(action.capabilityResponse.capability);
            return {
                ...state,
                capability: capability,
                loading: false
            }
        case FETCH_CYCLES_CALL_SUCCESS:
            const allCycles = JSON.parse(action.cyclesResponse.cycleList).filter(cycle => cycle.cycleId !== "AllCycles").map(cycle => {
                return {
                    ...cycle, displayableName: cycle.cycleId.replace('CYCLE_', '')
                }
            }).sort((cycle1, cycle2) => (cycle1.cycleName > cycle2.cycleName) ? 1 : ((cycle2.cycleName > cycle1.cycleName) ? -1 : 0));
            const selectedCycles = JSON.parse(action.cyclesResponse.selectedCycles).filter(cycle => cycle !== "AllCycles");
            const selectedCycleIds = allCycles.filter(cycle => selectedCycles.includes(cycle.cycleId)).map(cycle => cycle.casCycleId);
            return {
                ...state,
                options: {
                    ...state.options,
                    cycle: selectedCycles.length ? selectedCycles[0] : "",
                    cycleId: selectedCycleIds.length ? selectedCycleIds[0] : ""
                },
                allCycles: allCycles,
                loading: false
            };
        case FETCH_FILTERS_CALL_SUCCESS:
            return {
                ...state,
                allClusters: action.filters.allClusters,
                allAisles: action.filters.allAisles,
                clusterAislesMap: action.filters.clusterAislesMap,
                loading: false
            }
        case FETCH_OPTIONS_CALL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        case VIEW_CHANGED:
            return {
                ...state,
                heatMapView: action.view,
                isInitialView: false
            }
        default:
            // ALWAYS have a default case in a reducer
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/OptionsReducer.js